import type { ProgressBarManager } from './types';

export class ProgressBarManagerDisabled implements ProgressBarManager {
  openInitialProgressBar(_title: string): void {}

  startFakeProgressBarForCurrentApp(_shouldRestart?: boolean): void {}

  startFakeProgressBarForNextApp(): void {}

  pauseProgressBar(): () => void {
    return () => {};
  }

  closeProgressBar(): void {}
}
